import React from 'react';
import { Phone, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-logo">
              <img src="/emrys-text.png" alt="Emrys" className="logo-image" />
            </h3>
            <p className="footer-description">
              Your trusted travel companion for discovering amazing destinations 
              with personalized itineraries and expert local guides.
            </p>
          </div>


          {/* Popular Destinations */}
          <div className="footer-section">
            <h4>Popular Destinations</h4>
            <ul className="footer-links">
              <li><a href="#">Dubai</a></li>
              <li><a href="#">Bali</a></li>
              <li><a href="#">Singapore</a></li>
              <li><a href="#">Spain</a></li>
              <li><a href="#">Thailand</a></li>
              <li><a href="#">Japan</a></li>
            </ul>
          </div>


          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={16} />
                <span>+91-7447633655</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>emrysinternational01@gmail.com</span>
              </div>
            </div>
          </div>
        </div>


        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 Emrys. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#">Terms</a>
              <a href="#">Privacy</a>
              <a href="#">Cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
